import React, { useEffect, useState } from 'react';
import { 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer, 
    TableHead, 
    TableRow, 
    Paper,
    Grid, 
    List,
    Alert,
    ListItem,
    ListItemText,
    Typography, 
    Container,
    useMediaQuery,
    Stack,
    Pagination,
    Button,
    Box,
    TablePagination, 
    Tooltip
} from '@mui/material';
import exportFromJSON from 'export-from-json'
import styles from './HoldingsList.module.css';
import MyModal from "../../components/session_expired"
import MyLodder from '../lodder';
import xlsexport from 'xlsexport'
import notFound from "../../assets/svg/NotFound.svg" 
import { width } from '@mui/system';
const HoldingsList = ({ data ,showmodal,showlodder}) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [page, setPage] = useState(0);
  const [mpage, setMPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [mdata,setMdata] = useState([])  


  useEffect(()=>{
    const newArr = data && data.slice((mpage - 1)*5 ,(mpage)*5)
    setMdata(newArr)
  },[mpage,data])
  // const screen1200 = useMediaQuery("(max-width : 1200px)")  
    if (!data) {
        return null;
    }
    
    const  handlePageChange = (event, newpage) => { 
      setPage(newpage); 
    }
    const  handleMPageChange = (event, newpage) => { 
      setMPage(newpage); 
    }
    const handleRowsPerPageChange =(event) => { 
      setRowsPerPage(+event.target.value); 
      setPage(0); 
    }

    const customScrollbarStyles = {
      width : "100%",
      scrollbarWidth : "thin !important",
      scrollbarColor: 'rgba(170,170,170,0.4) transparent', 
    };

  const columns = [
    { id: 'SCRIP_SYMBOL', label: 'Symbol' },
    { id: 'NET', label: 'Quantity' },
    { id: 'PURCHASE_PRICE', label: 'Avg Cost' },
    { id:'BUYVAL',label:'Buy Value'},
    { id: 'SCRIP_VALUE', label: 'LTP' },
    { id: 'AMOUNT', label: 'Cur. Val' },
    { id: 'PANDL', label: 'P&L' }, 
    
    { id: 'PERCENT_HOLD', label: '% Holding' },
  ];
  const ExportDistWise=(data)=> {
    const fileName = "Holdings"
    const exportType = exportFromJSON.types.csv
    exportFromJSON({data,fileName,exportType})
}
  return (<Container sx={{padding: "0px !important" , margin: 0 , width : "100% !important"}}>
      {
        isSmallScreen ? ( <>
            <Typography variant="h6" sx={{margin : "30px 0px 0px 15px"}}>
              Holdings  
            </Typography>
            {/*  Download Button added */}
            <Grid style={{display:'flex',width:'100%',justifyContent:"flex-end"}}>
              <Button sx={{color : "#F3D45E", fontSize : "16px", background : "none" ,textDecoration : "underline",'&:hover': {
                backgroundColor: 'transparent', 
                textDecoration : "underline"
              }}}
              // Changed to onTouch event - 23-07-24 - Dev Srini
              onTouchStart={() => ExportDistWise(data)} 
              >Download</Button >
            </Grid>

            {data.length == 0 ? <Grid  style={{minHeight : "300px",display:'flex',justifyContent:'center', alignItems : "center", flexDirection : "column"}}>    
            <img  src={notFound}/>
            <Typography sx={{fontSize : "20px" , marginTop : "20px"}}>No Holdings Found</Typography>
        </Grid> :
            <List sx={{width : "100%", margin : "0px 0px 0px 5px" }}>
              {mdata?.map((item, index) => (
                <ListItem key={index} className={styles.listItem} sx = {{display : "flex" , flexDirection : "column" , alignItems : "start" ,borderBottom : "2px solid #000000",borderTop : index == 0 && "2px solid #000000"}}> 
                  <ListItemText
                  primary = {item.SCRIP_SYMBOL}
                  />
                  <ListItemText
                  sx={{width : "100%"}}
                  primary = {
                    <Box display="flex" >
                      <Grid width="40%">
                      <Typography className={styles.listPrimaryText}>Current Value</Typography>
                      </Grid>
                      <Grid width="40%" > 
                      <Typography className={styles.listPrimaryText} >QTY</Typography>
                      </Grid>
                      <Grid width="20%" > 
                      <Typography className={styles.listPrimaryText}>P&L</Typography>
                      </Grid>
                    </Box>
                  }
                  secondary = {
                    <Box display="flex">
                      <Grid width="40%">
                    <Typography marginRight= "15px" className={styles.listSecondaryText}>
                      {item.AMOUNT}
                      </Typography>
                      </Grid>
                      <Grid width="40%" >
                    <Typography className={styles.listSecondaryText} >
                      {parseInt(item.NET)}
                      </Typography>
                      </Grid>
                      <Grid width="20%" >
                    <Typography  sx = {{ 
                        color: parseFloat(item.PANDL) < 0 ? '#ff0400' : "#adff00", 
                      }} >{parseFloat(item.PANDL) < 0 ? parseFloat(item.PANDL).toFixed(2)  : `+${parseFloat(item.PANDL).toFixed(2)}`}</Typography>
                      </Grid>
                      
                    </Box>
                  }
                />
                <ListItemText
                  sx={{width : "100%"}}
                  primary = {
                    <Box display="flex" >
                      <Grid width="40%">
                      <Typography className={styles.listPrimaryText}>Avg</Typography>
                      </Grid>
                      <Grid width="40%" > 
                      <Typography className={styles.listPrimaryText} >LTP</Typography>
                      </Grid>
                      <Grid width="20%" > 
                      <Typography className={styles.listPrimaryText}>Holding</Typography>
                      </Grid>
                    </Box>
                  }
                  secondary = {
                    <Box display="flex">
                      <Grid width="40%">
                    <Typography marginRight= "15px" className={styles.listSecondaryText}>
                      {parseFloat(item.PURCHASE_PRICE).toFixed(2)}
                      </Typography>
                      </Grid>
                      <Grid width="40%" >
                    <Typography className={styles.listSecondaryText}>
                      {parseFloat(item.SCRIP_VALUE).toFixed(2)}
                      </Typography>
                      </Grid>
                      <Grid width="20%" >
                    <Typography className={styles.listSecondaryText}>{parseFloat(item.PERCENT_HOLD).toFixed(2)}</Typography>
                      </Grid>
                    </Box>
                  }
                />
                
                </ListItem>
              ))}
            </List>
            } 
            {data.length !==0 && <Grid sx={{display : "flex",justifyContent : "center"}}>
            <Pagination showFirstButton showLastButton count={Math.ceil(data.length / 5)} size="small" page={mpage} 
              onChange={handleMPageChange} />
            </Grid>}
     
        </>) : 
        <>
        {data.length > 0 && <Grid style={{ display: 'flex', width: '100%', background: "#180D2B"}}> 
        <Grid style={{display:'flex',width:'80%'}}>
        <Typography variant="h5" gutterBottom sx={{ background: "#180D2B",paddingTop : "10px", paddingBottom : "15px"}}> 
          Holdings
        </Typography>
        </Grid>
        <Grid style={{display:'flex',width:'20%',justifyContent:'flex-end'}}>
        <Button sx={{color : "#F3D45E", fontSize : "12px", background : "none" ,textDecoration : "underline",'&:hover': {
          backgroundColor: 'transparent', 
          textDecoration : "underline"
        }}}
          onClick={() => ExportDistWise(data)} 
        
        >Download</Button >
        </Grid>
        </Grid>}
        <TableContainer component={Paper} className={styles.tablecontainer} sx={customScrollbarStyles}>
         { data.length > 0 ? <Table sx={{width : "100%"}}> 
          <TableHead> 
            <TableRow>
              {columns.map((column,index) => (
                <TableCell className={styles.tablecellheader} sx={{paddingLeft : index == 0 ? "26px" : "0px" }} key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
              <TableRow key={index}>
                {columns.map((column) => (
                   <TableCell 
                   sx={{paddingLeft : column.id == "SCRIP_SYMBOL" ? "26px" : "0px" }}
                   className={`${styles.tablecell}`}
                   style={{color : column.id === "PANDL" && (parseFloat(row[column.id]) < 0 ? "#FF4747" : "#03E743")}}
                   key={column.id}>
                    <Tooltip title = {column.id == "SCRIP_SYMBOL" ? row.SCRIP_NAME : ""} placement='top-end'>
                    {column.id === "NET" ? parseInt(row[column.id]) : column.id === "SCRIP_SYMBOL" ? row[column.id]  : column.id == "PANDL" ? (parseFloat(row[column.id]).toFixed(2) < 0 ? parseFloat(row[column.id]).toFixed(2) : `+${parseFloat(row[column.id]).toFixed(2)}`) : parseFloat(row[column.id]).toFixed(2) }
                    </Tooltip>
                    </TableCell>
                ))}  
              </TableRow>
            ))}
          </TableBody>
        </Table> 
         : <Table sx={{background : "black" , height : "250px",display : "flex" , justifyContent : "center"}}>
        <TableRow  style={{display:'flex',alignItems : "center" , flexDirection : "column"}}> 
            {/* console errors correct -30-07-24 - Dev Srini  */}
          <TableCell>
            <img height={110} style={{marginTop : "30px"}} src={notFound}/>
            
          </TableCell>
          <Typography sx={{fontSize : "20px" , marginTop : "20px"}}>No Holdings Found</Typography>
        </TableRow> 
        </Table>}
        </TableContainer>    
        {data.length > 0 && <TablePagination
            sx={{ background: "#241E41"}}  
              rowsPerPageOptions={[10, 20, 50]}
              rowsPerPage={rowsPerPage}
              page={page}
              count={data.length}
              component="div"
             onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange} 
          />  }
      </>
      }
      <MyModal canShow={showmodal}/>
      <MyLodder canShow={showlodder}/>
    </Container>
  ); 
};

export default HoldingsList;
